import React, { useEffect } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useAuth } from 'auth/AuthContext';
import { setOnUnauthorized } from '../api/interceptors';
import WalletScreen from '../screens/WalletScreen';
import VirtualCardScreen from '../screens/VirtualCardScreen';
import CardSetupScreen from '../screens/CardSetupScreen';
import CardTransactionsScreen from '../screens/CardTransactionsScreen';

export type WalletStackParamList = {
  Wallet: undefined;
  VirtualCard: { cardId: string };
  CardSetup: undefined;
  CardTransactions: { cardId: string };
};

const Stack = createNativeStackNavigator<WalletStackParamList>();

const MainNavigator = () => {
  const { signOut } = useAuth();

  useEffect(() => {
    setOnUnauthorized(() => {
      signOut();
    });
  }, [signOut]);

  return (
    <Stack.Navigator
      screenOptions={{
        headerStyle: { backgroundColor: '#000000' },
        headerTintColor: '#FFDD00',
        headerTitleStyle: { fontWeight: '600' },
      }}
    >
      <Stack.Screen
        name="Wallet"
        component={WalletScreen}
        options={{
          title: 'Wallet',
        }}
      />
      <Stack.Screen
        name="VirtualCard"
        component={VirtualCardScreen}
        options={{ title: 'Virtual Card' }}
      />
      <Stack.Screen
        name="CardSetup"
        component={CardSetupScreen}
        options={{ title: 'Get Virtual Card' }}
      />
      <Stack.Screen
        name="CardTransactions"
        component={CardTransactionsScreen}
        options={{ title: 'Transactions' }}
      />
    </Stack.Navigator>
  );
};

export default MainNavigator;
